import { Message } from 'element-ui';

export const router_general=[//通用
  {
    meta: {
      title: '模板一',
    },
    path: '/',
    redirect:'online-learning',
    component: () => import('views/frameworkOne/index.vue'),
    children: [
      {
        meta: {
          title: '外部连接',
        },
        path: '/out-link-view',
        name: 'outLinkView',
        component: () => import('views/outLinkView/outLinkView.vue'),
        children: []
      },
      // ********************************在线学习***************************************
      {
        meta: {
          title: '在线学习',
        },
        path: '/online-learning',
        component: () => import('views/onlineLearning/index.vue'),
        children: [
          {
            meta: {
              title: '在线学习',
            },
            path: '/online-learning',
            name: 'onlineLearning',
            component: () => import('views/onlineLearning/onlineLearning.vue'),
          },
          {
            meta: {
              title:'学校管理人员课程'
            },
            path: '/online-learning/teacher-course/:id',
            name: 'teacherCourse',
            component: () => import('views/onlineLearning/children/teacherCourse/teacherCourse.vue'),
          },
          {
            meta: {
              title:'从业人员课程'
            },
            path: '/online-learning/student-course/:id',
            name: 'studentCourse',
            component: () => import('views/onlineLearning/children/studentCourse/studentCourse.vue'),
          },
          {
            meta: {
              title:'供餐企业管理人员课程'
            },
            path: '/online-learning/parent-course/:id',
            name: 'parentCourse',
            component: () => import('views/onlineLearning/children/parentCourse/parentCourse.vue'),
          },
          {
            meta: {
              title:'宣传视频'
            },
            path: '/online-learning/platform-course/:id',
            name: 'platformCourse',
            component: () => import('views/onlineLearning/children/platformCourse/platformCourse.vue'),
          },


        //=================================2019.09.19===============================================

          //详情
          {
            path: '/online-learning/detail',
            name: 'detail',
            meta:{
              title: '详情',
            },
            component: () => import('views/onlineLearning/children/Detail/Detail.vue'),
            beforeEnter: (to, from, next) => {
              if(to.name == "detail"){
                sessionStorage.setItem('routerFromInfo',JSON.stringify({'title':from.meta.title,'path':from.path}));
              }
              next();
            },
            children: [
              //视频详情
              {
                path: '/online-learning/videoDetails/:id',
                name: 'videoDetails',
                meta:{
                  title: '视频详情',
                },
                component: () => import('views/onlineLearning/children/Detail/components/VideoDtails/VideoDtails.vue'),
              },
              //文档详情
              {
                path: '/online-learning/documentDetails/:id',
                name: 'documentDetails',
                meta:{
                  title: '文档详情',
                },
                component: () => import('views/onlineLearning/children/Detail/components/DocumentDetails/DocumentDetails.vue'),
              },
              {
                path: '/online-learning/picture/:id',
                name: 'picture',
                meta:{
                  title: '图片详情',
                },
                component: () => import('views/onlineLearning/children/Detail/components/Picture/Picture.vue'),
              },
              //测验
              {
                path: '/online-learning/test/:id',
                name: 'test',
                meta:{
                  title: '测验',
                },
                component: () => import('views/onlineLearning/children/Detail/components/Test/Test.vue'),
              },
              //考试
              {
                path: '/online-learning/examination/:id',
                name: 'examination',
                meta:{
                  title: '考试',
                },
                redirect: '/online-learning/examtip/:id',
                component: () => import('views/onlineLearning/children/Detail/components/Examination/Examination.vue'),
                children:[
                  //考试统计
                  {
                    path:'/online-learning/examtip/:id',
                    name:'examtip',
                    meta:{
                      title: '考试统计',
                    },
                    component: () => import('views/onlineLearning/children/Detail/components/Examination/components/ExamTip/ExamTip.vue'),
                  },
                  //查看考试详情
                  {
                    path:'/online-learning/examDetail/:id',
                    name:'examDetail',
                    meta:{
                      title: '考试详情',
                    },
                    component: () => import('views/onlineLearning/children/Detail/components/Examination/components/ExamDetail/ExamDetail.vue'),
                  },
                  {
                    path:'/online-learning/beginexam/:id',
                    name:'beginexam',
                    meta:{
                      title: '开始考试',
                    },
                    component: () => import('views/onlineLearning/children/Detail/components/Examination/components/BeginExam/BeginExam.vue'),
                  }
                ],
              },
              //暂无数据资源
              {
                path:'/online-learning/404/:id',
                name:'404',
                component: ()=>import ('views/onlineLearning/children/Detail/components/NoResource/NoResource.vue')
              }
            ]
          },


        ]
      }
    ]
  }
]


export const routerConfig=[...router_general];
